import baseBunny from "./base_green/img_baseBunny_green.jpg";
import baseBunnyP from "./base_green/img_baseBunny_green_p.jpg";

import base from "./base_green/img_base_green.jpg";
import baseP from "./base_green/img_base_green_p.jpg";

import baseBunnyCrochet from "./base_green/img_baseBunnyCrochet_green.jpg";
import baseBunnyCrochetP from "./base_green/img_baseBunnyCrochet_green_p.jpg";

import baseBunnyCrochetRattle from "./base_green/img_baseBunnyCrochetRattle_green.jpg";
import baseBunnyCrochetRattleP from "./base_green/img_baseBunnyCrochetRattle_green_p.jpg";

import baseBunnyRattle from "./base_green/img_baseBunnyRattle_green.jpg";
import baseBunnyRattleP from "./base_green/img_baseBunnyRattle_green_p.jpg";

import baseCrochet from "./base_green/img_baseCrochet_green.jpg";
import baseCrochetP from "./base_green/img_baseCrochet_green_p.jpg";

import baseCrochetRattle from "./base_green/img_baseCrochetRattle_green.jpg";
import baseCrochetRattleP from "./base_green/img_baseCrochetRattle_green_p.jpg";

import baseRattle from "./base_green/img_baseRattle_green.jpg";
import baseRattleP from "./base_green/img_baseRattle_green_p.jpg";

export default [
    {
        type: "base",
        noPostcard: base,
        withPostcard: baseP,
    },
    {
        type: "baseBunny",
        noPostcard: baseBunny,
        withPostcard: baseBunnyP,
    },
    {
        type: "baseBunnyCrochet",
        noPostcard: baseBunnyCrochet,
        withPostcard: baseBunnyCrochetP,
    },
    {
        type: "baseBunnyCrochetRattle",
        noPostcard: baseBunnyCrochetRattle,
        withPostcard: baseBunnyCrochetRattleP,
    },
    {
        type: "baseBunnyRattle",
        noPostcard: baseBunnyRattle,
        withPostcard: baseBunnyRattleP,
    },
    {
        type: "baseCrochet",
        noPostcard: baseCrochet,
        withPostcard: baseCrochetP,
    },
    {
        type: "baseCrochetRattle",
        noPostcard: baseCrochetRattle,
        withPostcard: baseCrochetRattleP,
    },
    {
        type: "baseRattle",
        noPostcard: baseRattle,
        withPostcard: baseRattleP,
    }
]